import { getToken } from '../api/client/authentication';
import { useMemo } from 'react';
export const useToken = (clientId) => {
    const token = useMemo(() => getToken(clientId), [clientId]);
    return { token };
};
